import '../style/About.css'

const About = () => {
    return (
        <div className="about">
            <h2>Some things I've been spending my time on recently...</h2>
            <p>Just finished the AWS Cloud Practioner Cert, now working towards AWS Solutions Architect Associate</p>
            <p>Hosting trivia nights with friends (which motivated me to deploy Trivia Night!) </p>
            <p>Learning Japanese and trying out conlangs like Toki Pona through translating simple texts</p>
            <p>Designing games, usually focused on strategy or social deduction mechanics</p>
            <p>Dipping my toes into VR & Game development</p>
        </div>
    );
}

export default About;